import { render, staticRenderFns } from "./AddViewCategory.vue?vue&type=template&id=7222b30c&scoped=true"
import script from "./AddViewCategory.vue?vue&type=script&lang=js"
export * from "./AddViewCategory.vue?vue&type=script&lang=js"
import style0 from "./AddViewCategory.vue?vue&type=style&index=0&id=7222b30c&prod&scoped=true&lang=scss"
import style1 from "./AddViewCategory.vue?vue&type=style&index=1&id=7222b30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222b30c",
  null
  
)

export default component.exports